import axios from 'axios'

// // You can use your own logic to set your local or production domain
// var baseDomain = ''
// if (process.env.NODE_ENV === 'development') {
//   baseDomain = 'http://localhost:5000/api/'
// } else if (process.env.NODE_ENV === 'production') {
//   baseDomain = 'http://149.129.129.112:51000/api/'
// }

// Create axios instance without baseURL initially to avoid circular dependency
const apiClient = axios.create({
  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
})

// Use interceptor to set baseURL dynamically from store (lazy loading)
apiClient.interceptors.request.use((config) => {
  // Lazy import store to avoid circular dependency at module load time
  if (!config.baseURL) {
    const store = require('../store/index.js').default
    config.baseURL = store.getters.baseDomain
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

export default apiClient

